import { render, staticRenderFns } from "./PopularStock.vue?vue&type=template&id=35ff4564&scoped=true"
import script from "./PopularStock.vue?vue&type=script&lang=js"
export * from "./PopularStock.vue?vue&type=script&lang=js"
import style0 from "./PopularStock.vue?vue&type=style&index=0&id=35ff4564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff4564",
  null
  
)

export default component.exports